import Phaser from 'phaser';
import { SCENE_KEYS } from '../config/constants';
import { applyUiTokens } from '../ui/tokens';

/**
 * Первая сцена: сразу переключает на Preload.
 */
export class Boot extends Phaser.Scene {
  constructor() {
    super({ key: SCENE_KEYS.Boot });
  }

  create(): void {
    const uiRoot = document.getElementById('ui-root');
    if (uiRoot) applyUiTokens(uiRoot);
    this.scene.start(SCENE_KEYS.Preload);
  }
}
